// The About Page with the members and information about CSUS
import React from 'react';
import '../Styles/About.css';
import MemberCard from '../../Components/JS/MemberCard.js';
import people from '../../Data/People.js';
import Header from '../../Components/JS/Headers.js'
import Hero from '../../Components/JS/Hero'
import MetricCard from '../../Components/JS/MetricCard';
import metrics from '../../Data/Metrics';
import WhatWeDo from '../../Components/JS/WhatWeDo';
import ContactForm from '../../Components/JS/ContactForm'
import FAQ from '../../Components/JS/FAQ';

const About = () => {
    return ( 
        <div className="About" id="home">
            <Hero/>
            <div className="what-we-do-container"><WhatWeDo/></div>
            <div className="Metrics">
                <Header name="metrics" subheading="OUR METRICS" heading="What we've accomplished as a club"/>
                <div className="Club_metrics">
                    {metrics.map(metric => (
                        <MetricCard {...metric} />
                    ))}
                </div>
            </div>
            <div className="About_members">
            <div id="team">
                <Header name="members" heading="Meet the Team" subheading="WHO WE ARE"/>
                    <div className="About_member_cards">
                        {people.map(person => (
                            <MemberCard {...person} />
                        ))}
                    </div>
            </div>
            </div>
            <div id="contact">
                <ContactForm/>
            </div>
            <FAQ/>
        </div>
    );
}
 
export default About;
